import React from "react";
import Incidents, { type IncidentsTableProps } from "./Incidents.tsx";
import { resolveIncidentsNightTableContext } from "../../utils/nightScheduleEligibility.ts";

type Props = IncidentsTableProps;

/**
 * Incidencias de jefe directo: colaboradores de varias sucursales.
 * Horario nocturno solo si sucursal + turno «Nocturno» del colaborador;
 * si hay al menos uno, se usa el mayor corte operativo entre sucursales nocturnas.
 */
const IncidentsDirectBoss = (props: Props) => {
  const nightContext = React.useMemo(
    () =>
      resolveIncidentsNightTableContext(
        props.records,
        props.branchMetaMap ?? {},
        "directBoss"
      ),
    [props.records, props.branchMetaMap]
  );

  return (
    <Incidents
      {...props}
      hidePlannedColumns={nightContext.hidePlannedColumns}
      maxNightCutoffMinutes={
        nightContext.hasNocturnoPartners
          ? nightContext.maxNightCutoffMinutes
          : undefined
      }
    />
  );
};

export default IncidentsDirectBoss;
